export interface BazelRetryJob {
  buildType?: string | null;
  status?: number | null;
  dispatchJobId?: string | null;
}

export function canRetryBazelJob(job: BazelRetryJob): boolean {
  return job.buildType === 'package_bazel'
    && job.status === 35
    && !job.dispatchJobId;
}

export interface BazelRetryDependencies {
  confirm(options: {
    title: string;
    content: string;
    okText: string;
    cancelText: string;
    onOk: () => Promise<void>;
  }): void;
  submit(jobId: number): Promise<unknown>;
  reload(): Promise<void>;
  success(text: string): void;
  error(err: unknown): void;
}

export function createBazelRetryController() {
  const inflightJobIds = new Set<number>();

  return {
    open(jobId: number, deps: BazelRetryDependencies): void {
      if (inflightJobIds.has(jobId)) {
        return;
      }
      deps.confirm({
        title: '确认重试编译？',
        content: '使用上次 commit 重新编译，成功后继续执行仿真任务，是否继续？',
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          if (inflightJobIds.has(jobId)) {
            return;
          }
          inflightJobIds.add(jobId);
          try {
            await deps.submit(jobId);
            deps.success('已发起重试编译');
          } catch (err) {
            deps.error(err);
          }
          try {
            await deps.reload();
          } catch (err) {
            deps.error(err);
          } finally {
            inflightJobIds.delete(jobId);
          }
        },
      });
    },
  };
}
